import React, { useState, useEffect } from 'react';
import {
  Avatar,
  CircularProgress,
  Box
} from '@mui/material';
import { Face as FaceIcon } from '@mui/icons-material';
import { useAuthenticatedImage } from '../utils/imageUtils';

/**
 * Custom component for authenticated image avatar
 */
const AuthenticatedAvatar = ({ imageId, alt, ...props }) => {
  const [debugInfo, setDebugInfo] = useState(null);
  
  // Check if imageId is valid - AWS Rekognition might return null for ImageId
  const isValidImageId = imageId && typeof imageId === 'string' && imageId.trim() !== '';
  
  useEffect(() => {
    if (imageId) {
      console.log(`AuthenticatedAvatar imageId=${imageId} isValid=${isValidImageId}`);
      
      // Log debug info to console
      setDebugInfo({
        imageId,
        isValid: isValidImageId,
        type: typeof imageId,
        time: new Date().toISOString()
      });
    }
  }, [imageId, isValidImageId]);

  const { imageUrl, loading, error } = useAuthenticatedImage(isValidImageId ? imageId : null, 'thumbnail');
  const { imageUrl: fallbackUrl } = useAuthenticatedImage(error && isValidImageId ? imageId : null, 'serve');
  
  if (loading && isValidImageId) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 60, height: 60 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }
  
  if (error && debugInfo) {
    console.error('Failed to load image:', debugInfo, error);
  }
  
  return (
    <Avatar
      src={imageUrl || fallbackUrl}
      alt={alt}
      {...props}
    >
      {(!imageUrl && !fallbackUrl) && <FaceIcon />}
    </Avatar>
  );
};

export default AuthenticatedAvatar;
